import * as React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import ArtistContract from "assets/documents/Contrato_confidencialidad.pdf";
import DataAuthorizationFile from "assets/documents/Autorizacion_Data.pdf";
import FroinProposalFile from "assets/documents/froinProposal.pdf";
import PrivacyFile from "assets/documents/Politica_de_privacidad.pdf";
import TermsFiles from "assets/documents/Terminos_y_condiciones.pdf";
import LoyaltyContract from "assets/documents/Contrato_Loyalty_Comercio.pdf";
import TermsStandComercio from "assets/documents/Terminos y condiciones_Stand_Comercio.pdf";
import pageStyles from "./styles/renderLegalDocStyles";
import Model from "hooks/Model";

import { useContext } from "react";
import { Store } from "hooks/main_store";

const documents = {
  data: DataAuthorizationFile,
  artist: FroinProposalFile,
  terms: TermsFiles,
  privacy: PrivacyFile,
  artistContract: ArtistContract,
  loyaltyContract: LoyaltyContract,
  termsStandComercio: TermsStandComercio,
};

const RenderLegalDoc = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const nameDocument = urlParams.get("document") || "terms";
  const actionDocument = urlParams.get("action") || "";
  const {
    state: { loading: globalLoading },
  } = useContext(Store);

  // const { t } = useTranslation();
  const styles = pageStyles();
  const [numPages, setNumPages] = React.useState(0);
  const [loading, setLoading] = React.useState(true);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  React.useEffect(() => {
    if (!globalLoading && loading) {
      Model.setData("loading", true);
    } else if (!loading) {
      Model.setData("loading", false);
    }
  }, [globalLoading, loading]);

  React.useEffect(() => {
    Model.setData("loading", true);
    Model.setData("opacity", 0.7);
    Model.setData("layoutConfig", { withBg: true });

    if (actionDocument === "delete") {
      Model.setData("dialog", {
        open: true,
        title: "Eliminar mis datos de usuario",
        text: "Siguiendo nuestra política de tratamiento de datos, si en esta ocasión deseas eliminar tus datos de nuestra plataforma, escríbenos a [[WhatsApp]] para cualquier solicitud.",
        link: "https://api.whatsapp.com/send?app_absent=0&phone=573012069045&text=Tengo%20una%20solicitud%20&type=phone_number",
        txtRight: "Entendido",
        fnRight: () => {
          Model.setData("dialog", {
            open: false,
          });
        },
      });
    }

    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
  }, [actionDocument]);

  return (
    <Document
      file={documents[nameDocument] || documents.data}
      onLoadSuccess={onDocumentLoadSuccess}
      className={
        nameDocument === "artist" ? styles.container2 : styles.container
      }
    >
      {new Array(numPages).fill("page_").map((value, index) => (
        <Page pageNumber={index + 1} key={value + index} />
      ))}
      <div
        className={styles.cover}
        style={{
          maxHeight: numPages * (nameDocument === "artist" ? 4653 : 1035),
          height: `${numPages * (nameDocument === "artist" ? 4653 : 129)}${
            nameDocument === "artist" ? "px" : "vw"
          }`,
        }}
      />
    </Document>
  );
};

export default RenderLegalDoc;
